<!-- SERVER BANNER MESSAGE -->
<div class="alert" align="center" *ngIf="showAlert">
  <span class="closebtn" (click)="closeAlert();">&times;</span>
  <span [innerHTML]="serverBannerMessage"></span>
</div>

